import * as React from 'react';
import { connect, useDispatch, useSelector  } from 'react-redux';
import { useSnackbar } from 'notistack';
import axios from "axios";
import apiconfig from "../../../../../config/api-config.js";


import {
    fetchDefaultPlaylist,
    removeFromPlaylist,
    clearDefaultPlaylist,
    saveDefaultPlaylist,
    updatePlaylistFromLocal,
    loadLocalPlaylist
} from '../../../../FlikTraxStore/Actions/userActions';

import {
    addHiddenTrack
  } from "../../../../FlikTraxStore/Actions/apiActions";

import IconButton from '@mui/material/IconButton';
import Fade from '@mui/material/Fade';

import Tooltip from '@mui/material/Tooltip';
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove';

const RemoveFromPlaylist = (props) => {

    const { enqueueSnackbar } = useSnackbar();

    const dispatch = useDispatch();

    const Notify = (notification) => {
        enqueueSnackbar(notification, { variant: "success", autoHideDuration: 10000  });
    }

    const hiddenTracks = useSelector(state => state.api.hiddenTracks === undefined ? [] : state.api.hiddenTracks); 
    

    const popFromPlaylist = () => {
        console.log(hiddenTracks)
        axios({
            baseURL: "https://api.fliktrax.com/userplaylist",
            method: "post",
            auth: {
              username: apiconfig.api.APIUSERNAME,
              password: apiconfig.api.APIPASSWORD,
            },
            data: {
              cmd: "removedefault",
              userid: props.user.user.username,
              trackid: props.trackID
            },
            headers: {
              "Content-Type": "application/json",
            },
          }).then((response) => {
            let msg = props.trackTitle + " removed from playlist";
            Notify(msg);
            hiddenTracks.push(props.trackID)
            dispatch(addHiddenTrack(hiddenTracks));
            fetchDefaultPlaylist();
            loadLocalPlaylist();
            //console.log(response.data); return;
          });
        props.handleMobileMenuClose();
    };

    return (
            <React.Fragment>
                <Tooltip
                    TransitionComponent={Fade}
                    TransitionProps={{ timeout: 600 }}
                    title="Remove From Default Playlist"
                    placement="top"
                    arrow
                >
                    <IconButton onClick={() => popFromPlaylist()}
                        sx={{ padding: 1 }}
                        size="small"
                        aria-label="Add To Playlist"
                        color="secondary"
                    >
                        <PlaylistRemoveIcon style={{color:"red"}}  />
                    </IconButton>
                </Tooltip>
            </React.Fragment>
    );
}

function mapStateToProps(state) {
    return {
        api: state.api,
        user: state.user
    };
}

export default connect(mapStateToProps, {
    fetchDefaultPlaylist,
    addHiddenTrack,
    removeFromPlaylist,
    updatePlaylistFromLocal,
    loadLocalPlaylist
})(RemoveFromPlaylist);